import { render } from "./YButton.vue?vue&type=template&id=1fc0add2&scoped=true"
import script from "./YButton.vue?vue&type=script&lang=js"
export * from "./YButton.vue?vue&type=script&lang=js"

import "./YButton.vue?vue&type=style&index=0&id=1fc0add2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc0add2"]])

export default __exports__